import { Paper, PaperProps, styled } from "@mui/material";
import { useSelection, useUpdateSelectionMutation } from "hooks/selectionHooks";

import { LayerProperties, SelectionProperty } from "types";

import { LayerPropertyDropdown } from "./LayerPropertyDropdown";

interface Props extends PaperProps {
  config: string;
  layerProperties: LayerProperties[];
}

export function LayerPropertySelector(props: Props) {
  const { config, layerProperties, ...paperProps } = props;
  const { data: selection } = useSelection(config, layerProperties);

  const { mutateAsync: updateSelection } = useUpdateSelectionMutation(
    config,
    layerProperties
  );

  function onChange(selected: SelectionProperty) {
    if (selection) {
      const updatedProperties = selection.properties.reduce(
        (sel: SelectionProperty[], current: SelectionProperty) => {
          if (current.id === selected.id) {
            return [...sel, selected];
          }
          return [...sel, current];
        },
        []
      );
      updateSelection({ ...selection, properties: updatedProperties });
    }
  }

  return (
    <Styles elevation={0} {...paperProps}>
      {selection &&
        selection.properties.map((property) => (
          <LayerPropertyDropdown
            className="variant-input disable-helpertext-margin"
            key={property.id}
            property={property}
            onChange={onChange}
          />
        ))}
    </Styles>
  );
}

const Styles = styled(Paper)`
  display: flex;
  padding: ${({ theme }) => theme.spacing(0, 2)};
  background-color: ${({ theme }) => theme.palette.grey[800]};

  .variant-input + .variant-input {
    margin-left: ${({ theme }) => theme.spacing(2)};
  }
`;
